import { useEffect } from 'react'
import { useUnit } from 'effector-react'
import { useStyles } from './styles'

import { getTasksFx } from '@/entities/tasks/model/effects'

import { $userToken } from '@/entities/user'
import { $steamUserData } from '@/entities/platforms/steam/store'

import Task from './task'

import { getTaskVariant } from '@/shared/util/getTaskVariant'
import { TaskKind, TaskItem, TaskStatus } from '@/entities/tasks/model/types'

import { isTaskCooledDown } from '@/widgets/tasks/utils'

type TasksListProps = {
  tasksList: TaskItem[]
  isNews?: boolean
}

const TasksList = (props: TasksListProps) => {
  const { tasksList, isNews } = props

  const userToken = useUnit($userToken)
  const { classes } = useStyles({})
  const referredUsersAmount = useUnit($steamUserData)?.referal_info.referred_level_1 ?? 0

  useEffect(() => {
    if (userToken !== null) {
      getTasksFx({ token: userToken })
    }
  }, [userToken])

  return (
    <div className={classes.root}>
      {tasksList.map((task) => {
        const isTaskReady = isTaskCooledDown(task)
        if (task.name === 'streaks') return null
        if (task.name === 'tApps') return null
        return (
          <>
            <Task
              isNews={isNews}
              key={task.id}
              {...task}
              variant={getTaskVariant(task.kind)}
              isCompleted={task.repeatable ? !isTaskReady : task.status === TaskStatus.CLAIM}
              currentCount={task.kind == TaskKind.FRIENDS ? referredUsersAmount : null}
              maxCount={task.kind == TaskKind.FRIENDS ? task.payload.maxCount! : null}
            />
          </>
        )
      })}
    </div>
  )
}

export default TasksList
